<template>
  <div class="data-manage">
    <star-condition-layout
      :onSearch="getTableList"
      :onReset="reset"
      :loading="loading"
      ref="condition"
    >
      <star-condition-cell label="角色名称">
        <a-input v-model="search.userRoleName" placeholder="请输入关键字" allowClear />
      </star-condition-cell>
      <star-condition-cell label="角色状态">
        <a-select
          v-model="search.status"
          placeholder="请选择角色状态"
          style="width: 100%"
          @change="handleSearch"
        >
          <a-select-option :value="-1"> 停用</a-select-option>
          <a-select-option :value="1"> 启用</a-select-option>
        </a-select>
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-wrap">
      <TableHeadIcons :onRefresh="getTableList" :size.sync="tableDensity" :columns="columns">
        <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      </TableHeadIcons>
      <a-table
        :loading="loading"
        :size="tableDensity"
        :pagination="pagination"
        @change="handleTableChange"
        :rowKey="(record) => record.userRoleId"
        :columns="showColumns"
        :dataSource="dataSource"
      >
        <span slot="isDefault" slot-scope="text, record">{{
          record.isDefault == '1' ? '是' : '否 '
        }}</span>
        <span slot="status" slot-scope="text, record">{{
          record.status == '-1' ? '停用' : '启用 '
        }}</span>
        <div slot="action" slot-scope="text, record">
          <a-popconfirm title="确定要删除吗?" @confirm="() => handleDelete(record)">
            <a-button :disabled="!isAdmin" type="link">
              <a-icon type="delete" />
              删除
            </a-button>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a-button type="link" @click="handleEdit(record)" :disabled="!isAdmin">
            <a-icon type="edit" />
            修改
          </a-button>
        </div>
      </a-table>
    </div>
    <a-drawer
      :title="formModel == null ? '新增角色' : '修改角色'"
      width="600"
      :closable="true"
      :visible="visible"
      @close="visible = false"
    >
      <Form ref="form" v-if="visible" @refresh="handleRefresh" :formModel="formModel" />
    </a-drawer>
  </div>
</template>

<script>
import { queryRoleApi, deleteRoleApi } from '@/api/System/Role'
import Form from './Form.vue'

export default {
  data() {
    return {
      loading: false,
      visible: false,
      search: {
        userRoleName: undefined,
        status: undefined
      },
      tableDensity: 'middle',
      columns: [
        {
          title: '角色名称',
          ellipsis: true,
          dataIndex: 'userRoleName',
          show: true,
          width: 200
        },
        {
          title: '角色状态',
          scopedSlots: { customRender: 'status' },
          show: true,
          width: 90
        },
        {
          title: '是否默认角色',
          scopedSlots: { customRender: 'isDefault' },
          show: true,
          width: 150
        },
        {
          title: '备注',
          ellipsis: true,
          show: true,
          dataIndex: 'remark'
        },
        {
          title: '操作',
          width: 180,
          show: true,
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      sorter: {},
      formModel: null,
      isAdmin: false
    }
  },
  created() {
    this.getTableList()

    // 获取用户信息：
    const { userInfo } = this.$store.state
    if (userInfo || Array.isArray(userInfo.userRoles)) {
      userInfo.userRoles.forEach((item) => {
        if (item.roleSign === 'admin') {
          this.isAdmin = true
        }
      })
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  methods: {
    reset() {
      this.search.userRoleName = undefined
      this.search.status = undefined
      this.getTableList()
    },
    handleSearch() {
      this.pagination.current = 1
      this.getTableList()
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination
      if (sorter.order) {
        this.sorter = {
          orderKey: sorter.field,
          isAsc: sorter.order == 'ascend' ? true : false
        }
      } else {
        this.sorter = {}
      }
      this.getTableList()
    },

    handleReset() {
      this.search.status = undefined
      this.search.menuName = ''
      this.handleSearch()
    },

    //根据id删除数据
    async handleDelete(record) {
      const res = await deleteRoleApi({ ...record })
      const { code, msg } = res
      if (code == '200') {
        this.getTableList()
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },

    handleAdd() {
      this.visible = true
      this.formModel = null
    },

    handleEdit(record) {
      this.visible = true
      this.formModel = record
    },

    handleRefresh() {
      this.visible = false
      this.getTableList()
    },

    async getTableList() {
      let query = {
        ...this.search
      }
      this.loading = true
      let res = await queryRoleApi(query)
      this.loading = false
      let { code, msg, data } = res
      if (code == '200') {
        this.dataSource = data
      } else {
        this.$message.error(msg)
      }
    }
  },
  components: {
    Form
  }
}
</script>

<style lang="less" scoped>
.data-manage {
  padding: 16px;

  .search {
    padding: 16px;
    background: #fff;
    margin-bottom: 20px;
  }

  .table-wrap {
    background: #fff;
    padding: 0 20px 0 20px;
    margin-top: 16px;
  }
}
</style>
